import React from 'react'

import { Body2, Box, Display, Heading2, JustifyContent, Space } from '@gousto-internal/citrus-react'

import { LandingPageButton, TwoColumnLayout } from '../../components'
import type { HowGoustoFoodBoxesWorkTypes } from '../../types'
import { HowGoustoFoodBoxesWorkSections, TargetUri, TrackingActions } from '../../types/tracking'
import lifestyle from '../assets/lifestyle.jpg'
import { GOUSTO_WORTH } from './config'

export function GoustoWorthSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <TwoColumnLayout image={{ src: lifestyle, alt: GOUSTO_WORTH.altText }}>
      <Box width="100%">
        <Heading2>Ready to see if Gousto&apos;s worth it?</Heading2>
        <Space size={3} />
        <Body2 size={4}>
          Here&apos;s the deal: if you&apos;re after lots of variety, better value and less food
          waste, Gousto is the food box for you.
        </Body2>
        <Space size={2} />
        <Body2 size={4}>
          We&apos;re flexible, sustainable and packed with flavour – from global cuisines to speedy
          winners.
        </Body2>
        <Space size={6} />
        <Box
          display={Display.Flex}
          justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
        >
          <LandingPageButton
            startOnboarding={startOnboarding}
            sectionName={HowGoustoFoodBoxesWorkSections.GOUSTO_WORTH_SECTION}
            target={TargetUri.SIGNUP}
            action={TrackingActions.CLICK_GET_STARTED}
          >
            {GOUSTO_WORTH.ctaText}
          </LandingPageButton>
        </Box>
      </Box>
    </TwoColumnLayout>
  )
}
